import { Collapse } from 'antd';
const { Panel } = Collapse;

export default function CustomPanel(props) {
	return <Panel {...props} />;
}
